import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef} from "@angular/material/legacy-dialog";
import { CartOrderConfiguration } from '../cart-order/cart-order.configuration';
import { FlowListParameter } from 'src/app/core/classes/flow-list.parameter';
import { FLOW_STATE } from 'src/app/core/enums/flow-state';
import { FlowController } from 'src/app/core/controllers/flow.controller';
import { CtDatatableResult } from '@ctsolution/ct-framework';
import { Flow } from 'src/app/core/classes/flow';
import { FileService } from 'src/app/core/lib/file.service';
import { BaseFlowFileParameter } from 'src/app/core/classes/base-flow-file-parameter';
import { FlowApproveRequest } from 'src/app/core/classes/flow-approve-request';
import { FlowService } from 'src/app/core/lib/flow.service';

@Component({
  selector: 'app-preview-documents',
  templateUrl: './preview-documents.component.html',
  styleUrls: ['./preview-documents.component.scss']
})
export class PreviewDocumentsComponent implements OnInit {

  currentIndex = 0;
  params: FlowListParameter = new FlowListParameter();
  items: CartOrderConfiguration[] = [];
  selectedItem: CartOrderConfiguration | null = null;
  @ViewChild("iframe") iframe!: ElementRef;
  confirmedDocuments: Map<number, boolean> = new Map(); 

  createEstimatedPriceOrder = (flow: Flow) =>
    CartOrderConfiguration.create()
      .manageEstimatedPrice(true)
      .setFlow(flow);

  constructor( 
  private flowController: FlowController, 
  private fileService: FileService,
  private dialogRef: MatLegacyDialogRef<PreviewDocumentsComponent>,
  private flowService: FlowService) {
    // Percorso corretto del PDF
  }

  async ngOnInit() {

    await this.fetch();

    await this.setupSelectedItem();

  }

  async setupSelectedItem(){


    this.selectedItem = this.items[this.currentIndex];

    if (this.selectedItem) {

      const param: BaseFlowFileParameter = BaseFlowFileParameter.create(this.selectedItem.flow.Oid)
      await this.fileService.getFlowPreviewBlobUrl(param).subscribe(blob => this.iframe.nativeElement.src = blob);

    }

  }

  async prevFile() {

    if (!this.selectedItem || !this.items?.length) {
      return;
    }

    this.currentIndex = this.items.findIndex(item => item.flow.Oid === this.selectedItem?.flow.Oid);

    if (this.currentIndex > 0) {

      this.currentIndex = this.currentIndex - 1;

      this.selectedItem = this.items[this.currentIndex];

      if (this.selectedItem) {

        const param: BaseFlowFileParameter = BaseFlowFileParameter.create(this.selectedItem.flow.Oid)
        await this.fileService.getFlowPreviewBlobUrl(param).subscribe(blob => this.iframe.nativeElement.src = blob);

      }

    }

  }

  async nextFile() {

    if (!this.selectedItem || !this.items?.length) {
      return;
    }

    this.currentIndex = this.items.findIndex(item => item.flow.Oid === this.selectedItem?.flow.Oid);

    if (this.currentIndex !== -1 && this.currentIndex < this.items.length - 1) {

      this.currentIndex = this.currentIndex + 1;
      this.selectedItem = this.items[this.currentIndex];

      if (this.selectedItem) {

        const param: BaseFlowFileParameter = BaseFlowFileParameter.create(this.selectedItem.flow.Oid)
        await this.fileService.getFlowPreviewBlobUrl(param).subscribe(blob => this.iframe.nativeElement.src = blob);

      }

    }

  }

  async fetch() {

    this.params.FlowStates = [FLOW_STATE.PRICE_ESTIMATE];

    await this.flowController
      .list(this.params)
      .then((result: CtDatatableResult<Flow>) => {

        this.items = result.Items.map((flow: Flow) => this.createEstimatedPriceOrder(flow));

      });

  }

  toggleConfirmation(): void {

    if (!this.selectedItem) return;

    const oid = this.selectedItem.flow.Oid;
    const currentValue = this.confirmedDocuments.get(oid) || false;
    this.confirmedDocuments.set(oid, !currentValue);

  }

  getConfirmedOids(): number[] {

    return Array.from(this.confirmedDocuments.entries())
      .filter(([_, isConfirmed]) => isConfirmed)
      .map(([oid, _]) => oid);

  }

  get activateSubmit() : boolean {

    const confirmed = this.getConfirmedOids();

    return (confirmed.length > 0)

  }

  async submit(){

    const Oids = this.getConfirmedOids();
    
    if(Oids.length > 0)
    {

      const param : FlowApproveRequest = new FlowApproveRequest(false,Oids)
      const res = await this.flowController.approve(param)
      if(res) {

        this.flowService
        .getApprovalCount()

        this.flowService
        .getToSignCount()

        this.flowService
        .getCartCount()

        this.dialogRef.close(true)
      }

    }

  }

  async approveAll() {

    const param : FlowApproveRequest = new FlowApproveRequest(true)
    const res = await this.flowController.approve(param);

    this.flowService
    .getApprovalCount()

    this.flowService
    .getToSignCount()

    this.flowService
    .getCartCount()
    
    this.dialogRef.close(res)


  }

}
